<template>
  <div class="EnrollDetails">
    <TopNavBar navtitle="报名详情"></TopNavBar>
    <div class="enrolllist">
      <ul>
        <h1>{{ EB_Name }}</h1>
        <img class="papers" :src="Photo" alt="" />
        <i class="iconfont icon-baomingchenggong" v-if="IsPay == 1"></i>
        <li>
          <label for="">状态：</label>
          <van-tag round type="warning" v-if="CheckStatus == 0"
            >审核中...</van-tag
          >
          <van-tag round type="success" v-if="CheckStatus == 1"
            >审核通过</van-tag
          >
          <van-tag round type="danger" v-if="CheckStatus == 2"
            >审核未通过</van-tag
          >
        </li>
        <li>
          <label for="">报名费：</label>
          <van-tag round v-if="IsPay == 0" type="danger">未支付</van-tag>
          <van-tag round v-if="IsPay == 2" type="danger">已退费</van-tag>
          <van-tag round v-if="IsPay == 1" type="success">已支付</van-tag>
          <span class="fee" v-if="Fee > 0">￥{{ Fee }}</span>
        </li>
        <li v-if="IsPay == 1">
          <van-button
            type="primary"
            size="small"
            :to="'/AdmissionTicket?EF_ID=' + EF_ID"
            ><i class="iconfont icon-zhunkaozheng"></i
            >查看电子准考证</van-button
          >
          <!-- <van-button type="info" size="small" :to="'/EnrollDetails?EF_ID='+EF_ID"><i class="iconfont icon-xiangqing"></i>在线考试</van-button> -->
        </li>

        <p class="paydetail" v-if="EB_ID < 22 && EB_ID != 15">
          费用包含：报名费10元，证书费20元及{{ GName }}考务费{{ Fee - 30 }}元
        </p>
        <p class="paydetail" v-else>
          费用包含：报名费{{ 50 }}元和{{ GName }}考务费{{ Fee - 50 }}元。
        </p>

        <li class="btn-gather">
          <van-button v-if="IsPay == 0" type="danger" @click="CreatePay">{{
            this.IsOnlinePay == 0 ? "未缴费" : "立即支付"
          }}</van-button>
          <van-button v-if="IsPay == 0" type="info" @click="GotoEdit"
            >修改报名信息</van-button
          >
        </li>
        <li>
          <label for="">考试地点：</label>
          <span>{{ EAName }}</span>
        </li>
        <li>
          <label for="">报考专业：</label>
          <span>{{ MName }}</span>
        </li>
        <li>
          <label for="">报考级别：</label>
          <span>{{ GName }}</span>
        </li>
        <li>
          <label for="">考生姓名：</label>
          <span>{{ Name }}</span>
        </li>
        <li>
          <label for="">姓名拼音：</label>
          <span>{{ NameSpell }}</span>
        </li>
        <li>
          <label for="">性　　别：</label>
          <span>{{ Sex }}</span>
        </li>
        <li>
          <label for="">证件号：</label>
          <span>{{ CertNO }}</span>
        </li>
        <li>
          <label for="">出生日期：</label>
          <span>{{ BirthDate }}</span>
        </li>
        <li>
          <label for="">联系人：</label>
          <span>{{ PName }}</span>
        </li>
        <li>
          <label for="">联系电话：</label>
          <span>{{ PMobile }}</span>
        </li>
        <li>
          <label for="">培训机构/辅导老师：</label>
          <span>{{ TName }}</span>
        </li>
        <li>
          <label for="">老师电话：</label>
          <span>{{ TMobile }}</span>
        </li>
        <li>
          <label for="">报名时间：</label>
          <span>{{ CreateTime }}</span>
        </li>
      </ul>
    </div>
    <van-overlay :show="showload">
      <van-loading size="50px" vertical class="wrapper">加载中...</van-loading>
    </van-overlay>
  </div>
</template>

<script>
import TopNavBar from "@/components/TopNavBar.vue";
import { GetExamFormInfo } from "@/api/exam";
import { GetWeiXinUserInfo, CreateWeiXinPayUrl } from "@/api/weixin";
import wx from "weixin-js-sdk";

export default {
  components: { TopNavBar },
  data() {
    return {
      EF_ID: "",
      EB_Name: "",
      EB_ID: 0,
      IsPay: 0,
      Photo: "",
      CheckStatus: "",
      Fee: 0,
      EAName: "",
      MName: "",
      GName: "",
      Name: "",
      NameSpell: "",
      Sex: "",
      CertNO: "",
      BirthDate: "",
      PName: "",
      PMobile: "",
      TName: "",
      TMobile: "",
      CreateTime: "",
      WeiXinUserInfo: null,
      ip: "",
      payCode: "",
      IsOnlinePay: 0,
      PayState: false,
      showload: true,
      IsPost: false
    };
  },
  created() {
    if (this.$route.query.EF_ID != undefined && this.$route.query.EF_ID > 0) {
      GetExamFormInfo({ EF_ID: this.$route.query.EF_ID })
        .then(res => {
          let ExamInfo = res.item;
          this.EB_Name = ExamInfo.ExamBatch.EB_Name;
          this.EB_ID = ExamInfo.ExamBatch.EB_ID;
          this.IsPay = ExamInfo.IsPay;
          this.Photo = ExamInfo.Photo;
          this.CheckStatus = ExamInfo.CheckStatus;
          this.Fee = ExamInfo.Fee;
          this.EAName = ExamInfo.ExamArea.EA_Name;
          this.MName = ExamInfo.Majors.MName;
          this.GName = ExamInfo.Grades.GName;
          this.Name = ExamInfo.Name;
          this.NameSpell = ExamInfo.NameSpell;
          this.Sex = ExamInfo.Sex;
          this.CertNO = ExamInfo.CertNO;
          this.BirthDate = ExamInfo.BirthDate;
          this.PName = ExamInfo.PName;
          this.PMobile = ExamInfo.PMobile;
          this.TName = ExamInfo.TName;
          this.TMobile = ExamInfo.TMobile;
          this.CreateTime = ExamInfo.CreateTime;
          this.payCode = res.OtherMsg.PayCode;
          this.IsOnlinePay = ExamInfo.ExamArea.IsOnlinePay;
          this.EF_ID = ExamInfo.EF_ID;
          this.IsPost = ExamInfo.IsPost == 1 ? true : false;
          if (this.IsOnlinePay == 1 && this.IsPay == 0) {
            this.getCode();
          }
          let that = this;
          setTimeout(function() {
            that.showload = false;
          }, 2000);
        })
        .catch(err => {
          let that = this;
          setTimeout(function() {
            that.showload = false;
          }, 2000);
          console.log("err :>> ", err);
          // this.$router.push('/MyEnroll');
        });
    } else {
      this.$router.push("/MyEnroll");
    }
  },
  methods: {
    GotoEdit() {
      window.location.href =
        window.location.origin + "/ExamApply?EF_ID=" + this.$route.query.EF_ID;
    },
    getCode() {
      // 非静默授权，第一次有弹框
      this.code = "";
      var local = window.location.href;
      // var local = process.env.VUE_APP_DOMAIN_URL + window.location.hash;
      var appid = process.env.VUE_APP_WEIXIN_APPID;
      this.code = this.getUrlCode().code; // 截取code
      if (this.code == null || this.code === "") {
        // 如果没有code，则去请求
        window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${encodeURIComponent(
          local
        )}&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect`;
      } else {
        if (
          this.WeiXinUserInfo == null ||
          this.WeiXinUserInfo.openid == undefined ||
          this.WeiXinUserInfo.openid == ""
        ) {
          GetWeiXinUserInfo({ code: this.code })
            .then(response => {
              this.WeiXinUserInfo = Object.assign({}, response.item);
            })
            .catch(() => {
              window.location.href =
                window.location.origin +
                "/EnrollDetails?EF_ID=" +
                this.$route.query.EF_ID;
            });
        }
      }
    },
    getUrlCode() {
      // 截取url中的code方法
      var url = location.search;
      this.winUrl = url;
      var theRequest = new Object();
      if (url.indexOf("?") != -1) {
        var str = url.substr(1);
        var strs = str.split("&");
        for (var i = 0; i < strs.length; i++) {
          theRequest[strs[i].split("=")[0]] = strs[i].split("=")[1];
        }
      }
      return theRequest;
    },
    CreatePay() {
      if (this.PayState) {
        this.$dialog
          .alert({
            title: "提示",
            message: "您已经发起过支付，为避免造成重复缴费，页面将刷新"
          })
          .then(() => {
            // on close
            window.location.href =
              window.location.origin +
              "/EnrollDetails?EF_ID=" +
              this.$route.query.EF_ID;
          });
        return;
      }
      if (this.IsOnlinePay == 0) {
        this.$toast.success({
          message: "该地区不支持在线缴费，请到指定地点进行缴费"
        });
        return;
      }
      if (
        this.WeiXinUserInfo == null ||
        this.WeiXinUserInfo.openid == undefined ||
        this.WeiXinUserInfo.openid == ""
      ) {
        GetWeiXinUserInfo({ code: this.code })
          .then(response => {
            this.WeiXinUserInfo = Object.assign({}, response.item);
          })
          .catch(() => {
            window.location.href =
              window.location.origin +
              "/EnrollDetails?EF_ID=" +
              this.$route.query.EF_ID;
          });
      }
      this.$toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: "正在发起支付..."
      });

      this.PayState = true;
      CreateWeiXinPayUrl({
        PayCode: this.payCode,
        OpenID: this.WeiXinUserInfo.openid,
        IP: this.ip
      }).then(res => {
        this.$toast.clear();
        let data = res.OtherMsg;
        wx.ready(function() {
          wx.chooseWXPay({
            appId: data.appid,
            timestamp: data.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
            nonceStr: data.nonceStr, // 支付签名随机串，不长于 32
            package: data.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
            signType: "MD5", // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
            paySign: data.paySign, // 支付签名
            success: function(res) {
              //跳转到支付成功页面有这个页面
              this.$toast.success({ message: "支付完成..." });
              setTimeout(() => {
                window.location.href =
                  window.location.origin +
                  "/EnrollDetails?EF_ID=" +
                  this.$route.query.EF_ID;
              }, 3000);
            }
          });
        });
      });
    }
  }
};
</script>

<style>
.paydetail {
  padding: 10px 15px 0 15px;
  color: #888;
  text-align: left;
  font-size: 3.2vw;
  line-height: 1.6;
}
</style>
